import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';


const temp = [
    {
        id: '1',
        name: '托物言志',
        subtitle: '〈愛蓮說〉｜〈醜石〉',
        image: '/secondary/temp/1.png'
    }, {
        id: '2',
        name: '借事說理',
        subtitle: '〈傷仲永〉｜〈習慣說〉',
        image: '/secondary/temp/2.png'
    },
    {
        id: '3',
        name: '平淡之宗',
        subtitle: '〈桃花源記〉｜〈歸園田居〉',
        image: '/secondary/temp/3.png'
    },
    {
        id: '4',
        name: '唐詩氣象',
        subtitle: '〈月下獨酌（其一）〉｜〈山居秋暝〉｜〈登樓〉',
        image: '/secondary/temp/4.png'
    },
    {
        id: '5',
        name: '孔孟之道',
        subtitle: '〈論仁、論孝、論君子〉｜〈魚我所欲也〉',
        image: '/secondary/temp/5.png'
    }
]
function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [total, settotal] = useState(0)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateStatus = (newValue) => {
        searchParams.delete('status')
        searchParams.set('status', newValue)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result.result)
            settotal((result.count || 0) + temp.length)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(() => fetchData(true), 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px] ' style={{ fontSize, backgroundImage: 'url(/secondary/bg9.png)', backgroundSize: 'contain', backgroundPosition: 'right', backgroundRepeat: 'no-repeat' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[900] ' style={{fontSize: fontSize + 4}}>學習記錄</div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-row w-full flex-wrap px-[16px] justify-start items-start  overflow-auto gap-[8px]'>
                {data?.map((item, index) =>
                    <div key={item?._id} className='relative flex-1 flex flex-row gap-[8px] rounded-[16px] max-w-[500px] min-w-[33%] font-bold overflow-hidden bg-white' style={{border:'1px solid #E0E0E0'}}>
                        <div className='flex-1 flex flex-col'>
                            <img src={item?.mission.photo} alt={item?.mission?.name} className='w-full object-cover rounded-[16px]' style={{aspectRatio: '228/119'}} />
                            <div className='p-[16px]' style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{item?.mission?.name}</div>
                        </div>
                        <div className='flex-1 flex-col p-[8px] flex justify-start gap-[8px]' style={{fontSize: fontSize-2}}>
                            <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>{item.mission?.categories[0]}</div>
                                <button className='flex-1 text-[#A9FFDC] bg-[#009191] rounded-full px-[24px] py-[8px]'>查看成績</button>
                            </div>
                            <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>{item.mission?.categories[1]}</div>
                                <button className='flex-1 text-[#A9FFDC] bg-[#009191] rounded-full px-[24px] py-[8px]'>查看成績</button>
                            </div>
                             <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>單元習題</div>
                                <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{background:'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)'}}>未完成</button>
                            </div>
                           
                        </div>
                    </div>
                )}
                 {data&&temp?.map((item, index) =>
                    <div key={item?._id} className='relative flex-1 flex flex-row gap-[8px] rounded-[16px] max-w-[500px] min-w-[33%] font-bold overflow-hidden bg-white' style={{border:'1px solid #E0E0E0'}}>
                        <div className='flex-1 flex flex-col'>
                            <img src={item?.image} alt={item?.name} className='w-full object-cover rounded-[16px]' style={{aspectRatio: '228/119'}} />
                            <div className='p-[16px]' style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{item?.name}</div>
                        </div>
                        <div className='flex-1 flex-col p-[8px] flex justify-start gap-[8px]' style={{fontSize: fontSize-2}}>
                            <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>文化傳統</div>
                                <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{background:'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)'}}>未完成</button>
                            </div>
                            <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>作者處境</div>
                                <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{background:'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)'}}>未完成</button>
                            </div>
                             <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                <div className='flex-1'>單元習題</div>
                                <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{background:'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)'}}>未完成</button>
                            </div>
                           
                        </div>
                    </div>
                )}
               
        
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
